import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { MeteorUser } from '../../../../../../backend/server/data-models/meteor-user/meteor-user';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user/user.service';
import { TranslatorService } from '../../../core/translator/translator.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-verify-registration',
  templateUrl: './verify-registration.component.html',
  styleUrls: ['./verify-registration.component.scss']
})
export class VerifyRegistrationComponent implements OnInit, OnDestroy {

  user: MeteorUser;
  token: string
  valForm: FormGroup;

  private routeSubscription: Subscription;

  constructor(
    private translateService: TranslateService,
    private translatorService: TranslatorService,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    public router: Router,
    fb: FormBuilder,
    private userService: UserService
  ) {
    this.translatorService.useLanguage();

    this.routeSubscription = route.params.subscribe(params => {
      this.token = params['token'];
      console.warn("VERIF TOKEN " + this.token);
      if (this.token) {
        Accounts.verifyEmail(this.token, (err) => {
          if (!err) {
            this.ngZone.run(() => this.router.navigate([''])).then();
          }
        })
      }
    });

    this.valForm = fb.group({
      'email': ["", Validators.compose([Validators.required, CustomValidators.email])]
    });

    this.user = Meteor.user();
    if (this.user) {
      const unverified = this.user.emails.filter(e => e.verified !== true)[0];
      if (unverified) {
        this.valForm.controls["email"].patchValue(unverified.address);
      } else {
        this.ngZone.run(() => this.router.navigate(['/'])).then();
      }
    }
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.routeSubscription) this.routeSubscription.unsubscribe();
  }

  submitForm() {
    let emailControl = this.valForm.controls["email"];
    emailControl.markAsTouched();
    if (emailControl.invalid) return;

    const email = emailControl.value;
    this.userService.sendVerificationEmail(email);
  }

  onSigninClick() {
    this.router.navigate(['/login']);
  }

}
